import { format } from 'date-fns'

interface PeriodTitleProps {
  title: string
  isCurrent: boolean
  asOfDate: Date
}

/** A billing card's title: what the card shows, for which period, as of
 *  when. Callers supply the element it sits in. */
export function PeriodTitle({ title, isCurrent, asOfDate }: PeriodTitleProps) {
  return (
    <>
      {title} · {isCurrent ? 'This Month' : 'Period'} ·{' '}
      {/* The date keeps its own casing: it is a value, not part of the
          label, and the eyebrow's uppercase would shout it. */}
      <span className="font-normal normal-case tracking-normal">
        As of {format(asOfDate, 'MMM d, yyyy')}
      </span>
    </>
  )
}
